import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { vehicleService } from '../../Services/vehicle.service';
import ModalSpinner from '../Components/ModalSpinner';

export default function ModalRevisePlates(props) {
    const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [viewOnly, setViewOnly] = useState(props.viewOnly);
  const [showFields, setShowFields] = useState(props.showFields);
  const [show, setShow] = useState(false);



    const onRevisePlate = async () => {
        setIsLoading(true)
        try {
        const response = await vehicleService.plateIssues()
        if (response){
            return response
        }
        } catch (error) {
        console.log(error)
        }finally {
            setIsLoading(false);
        }
    }

    const handleSelect = async (item) => {
      
      try {
        const vehicles = await vehicleService.byPlateCodeInternal(item.plate);
        // A API retorna um array, então pegamos o primeiro item
        if (vehicles && vehicles.length > 0) {
          props.handleSelectVehicle(vehicles[0]); 
        }
      } catch (error) {
        console.error(error);
      } finally {
        setShow(false);
        props.handleClose(false); // Fecha o modal após selecionar
      }
    };
    

  const handleClose = () => props.handleClose(!props.show);


  useEffect(() => {
    const fetchData = async () => {
      if (props.show === true) {
        
        const response = await onRevisePlate();
        if(response){
            setData(response)
        }
      }
    };
  
    fetchData();
  }, [props.show]);
  
    
  return (
    <Modal
        show={props.show}
        onHide={handleClose}
        size='xl'
        dialogClassName="my-4"
    >
        <Modal.Header closeButton>
          <Modal.Title>Veiculos a serem revisados</Modal.Title>
        </Modal.Header>

        <Modal.Body className="overflow-auto" style={{ maxHeight: '600px' }}>
          {isLoading ? (
            <>
              <h5>Buscando...</h5>
              <ModalSpinner />
            </>
          ) : (
            <>
              {data ? (
                <>
                  <div className='card'>
                    <h5 className='card-header'></h5>
                    <div className='card-body'>
                      <table className='table table-bordered'>
                        <thead>
                          <tr>
                            <th>Cliente</th>
                            <th>Placa</th>
                            <th>Placas adicionais</th>
                          </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((item, index)=> (
                                    <tr style={{ cursor: "pointer" }} onClick={() => handleSelect(item)} key={index}>
                                        <td>{item.clientName}</td>
                                        <td>{item.plate}</td>
                                        <td>{item.plateRef}</td>
                                    </tr>
                                ))
                            }
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <h5>
                    😅Sem registros encontrados para este filtro. Mude seu
                    filtro e tente novamente!
                  </h5>
                </>
              )}
            </>
          )}
        </Modal.Body>

    </Modal>
  )
}
